import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports

// Set the default state values for each context
const GuideDrawerContext = /*#__PURE__*/createContext({});
const useGuideDrawerHook = () => {
  const [isGuideOpen, setIsGuideOpen] = React.useState(false);
  const toggleGuide = () => {
    setIsGuideOpen(!isGuideOpen);
  };
  return {
    isGuideOpen,
    toggleGuide
  };
};
export const GuideDrawerContextProvider = ({
  children
}) => {
  const guideDraw = useGuideDrawerHook();
  return /*#__PURE__*/React.createElement(GuideDrawerContext.Provider, {
    value: guideDraw
  }, children);
};
export const useGuideDrawer = () => {
  return useContext(GuideDrawerContext);
};
GuideDrawerContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};